import React, { useState } from "react";
import { MonthView } from "components/DatePicker/MonthView";
import type { Dayjs } from "dayjs";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { type DateRateFomatted } from "apis/calendarRates";

type RangePickerHorizontalProps = {
  firstMonth: Dayjs;
  datePropsFn: (date: Dayjs) => {
    selected: boolean;
    inBetweenSelected: boolean;
  };
  onHoverDate: (date: Dayjs) => void;
  onClickDate: (date: Dayjs) => void;
  dateRate: Record<string, DateRateFomatted> | null;
  note?: string;
};

export const RangePickerHorizontal = ({
  firstMonth,
  datePropsFn,
  onHoverDate,
  onClickDate,
  dateRate,
  note,
}: RangePickerHorizontalProps) => {
  const [month, setMonth] = useState(firstMonth);
  const { t } = useTranslation("homepage");

  const onPrev = () => setMonth(month.subtract(1, "month"));
  const onNext = () => setMonth(month.add(1, "month"));

  return (
    <div className="relative border rounded p-28 border-gold-disabled shadow-booking-form-desktop bg-white">
      <div className="relative flex justify-between gap-24 ">
        <div className="absolute top-32 left-24" onClick={onPrev}>
          <span className="cursor-pointer ay-icon-left-arrow-thin text-gold text-24" />
        </div>
        <div className="absolute top-32 right-24" onClick={onNext}>
          <span className="cursor-pointer ay-icon-right-arrow-thin text-gold text-24" />
        </div>
        <MonthView
          month={month}
          datePropsFn={datePropsFn}
          onHoverDate={onHoverDate}
          onClickDate={onClickDate}
          plainAndScrollable={false}
          dateRate={dateRate}
        />
        <MonthView
          month={month.add(1, "month")}
          datePropsFn={datePropsFn}
          onHoverDate={onHoverDate}
          onClickDate={onClickDate}
          plainAndScrollable={false}
          dateRate={dateRate}
        />
      </div>
      {note && <p className="text-center text-12 font-mulish">{note}</p>}
    </div>
  );
};
